(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/assets/hooks/use-debounce.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/assets/hooks/use-debounce.js');

'use strict';

const {
  useRef
} = React;
const useDebounce = _ref => {
  let {
    callback,
    delay = 500,
    immediate = false
  } = _ref;
  const callbackRef = useRef();
  const debouncedCallbackRef = useRef();
  if (callbackRef.current !== callback) {
    callbackRef.current = callback;
    debouncedCallbackRef.current = _.debounce(callback, delay, immediate);
  }
  return debouncedCallbackRef.current;
};
Object.assign(svs.lyckoplatsen.hooks, {
  useDebounce
});

 })(window);